import { Date } from "../../Date";
import { getDecisionPreview } from "../../../api/decision/preview";
import { Link } from "react-router-dom";
import { StyledDecisionCardTags } from "../../../styles/StyledDecisionCard";
import { StyledDecisionPreview } from "../../../styles/StyledDecisionPreview";
import { Tag } from "../../Tag";
import { useAppContext } from "../../../context/appContext";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useState } from "react";
import convertStringToColor from "../../../helpers/util/convertStringToColor";
import ModalHeader from "../../ModalHeader/ModalHeader";
import moment from "moment";
import PropTypes from "prop-types";
import QueryLoader from "../../Loader/QueryLoader";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function DecisionPreview({ decisionId, closeModal, clearSearchResults, decisionsList }) {
	const { items } = useAppContext();
	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, isError, error, data } = useQuery(["decision-preview", decisionId], () =>
		getDecisionPreview(axiosPrivate, decisionId)
	);
	const [dates, setDates] = useState({ decisionDate: null, validFrom: null, validTo: null });
	const [acronym, setAcronym] = useState("");

	useEffect(() => {
		if (isError) console.log(error);
	}, [decisionId]);

	useEffect(() => {
		if (data) {
			let a = "";
			if (data.unit.name.split(" ").length > 1) {
				data.unit.name.split(" ").map((e, i) => {
					if (i < 2) a += e.split("")[0];
				});
			} else {
				data.unit.name.split("").map((e, i) => {
					if (i < 2) a += e;
				});
			}
			setAcronym(a);
		}
	}, [data, isLoading]);

	useEffect(() => {
		if (data) {
			const decisionDate = moment(data.decisionDate);
			const validFrom = moment(data.validFrom);
			const validTo = moment(data.validTo);

			setDates({
				decisionDate: decisionDate.format("YYYY-MM-DD"),
				validFrom: validFrom.format("YYYY-MM-DD"),
				validTo: validTo.format("YYYY-MM-DD"),
			});
		}
	}, [data]);

	if (isLoading || isError) {
		return <QueryLoader />;
	}

	return (
		<>
			<ModalHeader onClick={() => closeModal()} data-testid="overviewEdit-modalHeader">
				{data.name}
			</ModalHeader>
			<StyledDecisionPreview color={convertStringToColor(data.unit.name)}>
				{(data?.shortBasis || data?.shortDecision) && (
					<div className="description-container">
						{data?.shortBasis && (
							<div className="description-single">
								<span>Basis</span>
								<p>{data.shortBasis}</p>
							</div>
						)}
						{data?.shortDecision && (
							<div className="description-single">
								<span>Decision</span>
								<p>{data.shortDecision}</p>
							</div>
						)}
					</div>
				)}
				{(data?.shortBasis || data?.shortDecision) && <span className="divider"></span>}
				<div className="details-container">
					<div className="dates-container">
						<div>
							<span>Decision Date</span>
							<Date>{dates.decisionDate}</Date>
						</div>
						<div>
							<span>Valid from</span>
							<Date>{dates.validFrom}</Date>
						</div>
						<div>
							<span>Valid to</span>
							<Date>{dates.validTo}</Date>
						</div>
					</div>
					<div className="unit-container">
						<div className="icon">
							<span>{acronym}</span>
						</div>
						<span>Unit</span>
						{data.unit.name}
					</div>
					<div className="labels-container">
						<div>
							<span>Category</span>
							{data.category.name}
						</div>
						<div>
							<span>Reference nr</span>
							{data.referenceNumber}
						</div>
						<div>
							<span>Direction</span>
							<Link
								onClick={() => {
									if (clearSearchResults) {
										localStorage.removeItem("search");
									}
									localStorage.setItem("decisionsList", JSON.stringify(decisionsList));
								}}
								to={`/decisions/${data.id}?directionsTab=true&isMaker=${
									Object.keys(items.userUnits).length !== 0 && items.userUnits[data.unit.id] ? "true" : "false"
								}`}
							>
								Check the direction
							</Link>
						</div>
					</div>
				</div>
				{data.keywords.length > 0 && (
					<>
						<span className="divider"></span>
						<StyledDecisionCardTags justify="left">
							{data.keywords.map((keyword, i) => (
								<Tag key={i}>{keyword}</Tag>
							))}
						</StyledDecisionCardTags>
					</>
				)}
				{Object.keys(items.userUnits).length !== 0 && items.userUnits[data.unit.id] && (
					<Link
						onClick={() => {
							if (clearSearchResults) {
								localStorage.removeItem("search");
							}
							localStorage.setItem("decisionsList", JSON.stringify(decisionsList));
						}}
						to={`/decisions/${data.id}`}
					>
						See more
					</Link>
				)}
			</StyledDecisionPreview>
		</>
	);
}

DecisionPreview.propTypes = {
	decisionId: PropTypes.number,
	closeModal: PropTypes.func,
	clearSearchResults: PropTypes.bool,
	decisionsList: PropTypes.array,
};
